<template>
  <b-button
    outlined
    :size="size"
    :class="{'is-short': isShort}"
    :type="color"
    :icon-left="iconLeft"
    :icon-right="iconRight"
    :loading="loading"
    @click="$emit('click', $event)"
  >
    <slot></slot>
  </b-button>
</template>

<script>
export default {
  name: "ButtonDefault",
  props: {
    size: {
      type: String,
      default: 'is-small'
    },
    color: {
      type: String,
      default: 'is-primary'
    },
    iconLeft: {
      type: String
    },
    iconRight: {
      type: String
    },
    loading: {
      type: Boolean
    },
    isShort: {
      type: Boolean,
      default: false,
    },
  }
}
</script>
